import { render, staticRenderFns } from "./DamDischargeInfoTable.vue?vue&type=template&id=fff6ec3e&scoped=true"
import script from "./DamDischargeInfoTable.vue?vue&type=script&lang=ts"
export * from "./DamDischargeInfoTable.vue?vue&type=script&lang=ts"
import style0 from "./DamDischargeInfoTable.vue?vue&type=style&index=0&id=fff6ec3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fff6ec3e",
  null
  
)

export default component.exports